<div class="innerContainer promotionsConditions">
  <h1 class="vc-title-l promotionsConditions__title" i18n="@@PROMOTIONS_CONDITIONS.TITLE">
    Promotion Terms & Conditions
  </h1>
  <p *ngIf="contentLegals" class="promotionsConditions__paragraph vc-body">{{ contentLegals }}</p>
  <p
    *ngIf="!contentLegals"
    class="promotionsConditions__paragraph vc-body"
    i18n="@@PROMOTIONS_CONDITIONS.ACTUALLY_NO_PROMOTION"
  >
    There are currently no promotional offer.
  </p>
</div>
